import React, {useCallback, useState} from 'react';

export function useInputState(initialValue: string) {
	const [value, setValue] = useState(initialValue);

	const handleChange = useCallback((event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
		setValue(event.currentTarget.value);
	}, []);

	return [value, handleChange, setValue] as const;
}

useInputState.displayName = 'useInputState';
